import { render, staticRenderFns } from "./gift_card_selector.vue?vue&type=template&id=64ef058b"
import script from "./gift_card_selector.vue?vue&type=script&lang=js"
export * from "./gift_card_selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johnmartin/Repos/whitefox-shopify-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64ef058b')) {
      api.createRecord('64ef058b', component.options)
    } else {
      api.reload('64ef058b', component.options)
    }
    module.hot.accept("./gift_card_selector.vue?vue&type=template&id=64ef058b", function () {
      api.rerender('64ef058b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/gift_card_selector.vue"
export default component.exports